import { Component, OnInit, Input, Testability, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../_services/data.service';
import { Item } from '../../../_core/_interface/item';
import { Flat } from '../../../_core/_interface/flat';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { prototype } from 'events';
import { threadId } from 'worker_threads';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';

export function isFullScreen(): boolean {
  const fsDoc = <any>document;

  return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
}
interface FsDocumentElement extends HTMLElement {
  msRequestFullscreen: () => void;
  mozRequestFullScreen: () => void;
  webkitRequestFullscreen: () => void;
}

@Component({
  selector: 'app-offer-flat-properties',
  templateUrl: './offer-flat-properties.component.html',
  styleUrls: ['./offer-flat-properties.component.scss']
})
export class OfferFlatPropertiesComponent implements OnInit {
  items: Flat = {
    number: 0,
    buildId: '',
    compId: '',
    floorId: '',
    projId: '',
    startPoint: 0,
    name: '',
    flatSize: 0,
    numberOfBathrooms: 0,
    uid: '',
    faltPrototype: '',
    builUid: '',
    floorNumber: 0,
    id: '',
    curFloorPanorama: ''
  };

  showContent = false;
  itemToEdit: Item;
  fullScreenDrawing = false;
  fullScreenSpirical = false;
  fullScreenInterior = false;
  fullScreenGallery = false;
  public compId;
  public flatProperties;
  fullscreen = false;
  fullScreen: boolean = false;
  // routeNavigate: any;
  slide: boolean;
  iframeElement;
  proj: any;
  mainSpiricalSrc = "";
  showCopyNote: boolean = false;
  removeAllMenu: any;

  // @Input()
  // floorId: string;
  // @Input()
  // projId: string;
  // @Input()
  // projUid: string;
  @Input()
  buildingUid: any;
  @Input()
  flatId: any;
  @Input()
  offer: any;
  // @Input()
  buildName: any;
  // elRef: any;
  // observer: any;
  building: any;
  flat: any;
  // flatId: string = "KczVdkb11DkClGt";
  mainSpiricalSrcUpdated: boolean = false;
  // showPhone: boolean = false;
  // showPhoneNumber: boolean = false;
  // phoneNumber: number;
  removeCloseButton: boolean = false;
  companyTitle: any;
  projectTitle: any;
  withBuilding: boolean = false;
  offerUid: string;
  desktopResolution: boolean = false;
  // builUid: string = "aIQY9M4CNtQh2v5";
  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService) {
    // this.flatId = this.route.snapshot.params.flatId;
  }

  ngOnInit() {
    // this.projUid = this.route.snapshot.paramMap.get('idp');
    this.removeAllMenu = localStorage.getItem('removeAllMenu');
    // offerUid
    this.offerUid = this.route.snapshot.params.offerUid;
    let companyAndProject = null;
    if (companyAndProject === null) {
      setTimeout(() => {
        companyAndProject = localStorage.getItem('companyAndProject');
        const objcompanyAndProject = JSON.parse(companyAndProject);
        this.companyTitle = objcompanyAndProject.companyName;
        this.projectTitle = objcompanyAndProject.projectName;
      }, 500);
    } else {
      const objcompanyAndProject = JSON.parse(companyAndProject);
      this.companyTitle = objcompanyAndProject.companyName;
      this.projectTitle = objcompanyAndProject.projectName;
    }
    if (this.route.snapshot.queryParams.m === 'all') {
      this.removeCloseButton = true;
    }
    // this.routeNavigate = location.hostname + this.router.url;
    const dataService = this.dataService;
    // this.dataService.getSpecialOffer(this.offerUid).subscribe(offer => {
    //   console.log(offer)
      
      this.flat = this.offer.flatsArray[0];
      if (this.flat.faltPrototype !== '' || this.flat.faltPrototype !== undefined) {
        this.dataService
          .getSpecFlatPrototypeView(this.flat.faltPrototype)
          .subscribe(prototype => {
            this.flatProperties = prototype[0];
          });
      }
    // });
    if (window.innerWidth > 1200) {
      this.desktopResolution = true;
    }
    if (this.buildingUid !== "") {
      // this.dataService.getSpecBuilding(this.buildingUid).subscribe(building => {
      //   this.building = building[0];
      //   this.buildName = building[0].name;
      //   this.withBuilding = building[0].withBuilding;
      //   console.log(this.building);
      //   let floors = this.building.floors;
      //   floors.forEach(floor => {
      //     let currentFlats = floor.floor.flats.filter(flat => flat.id === this.flatId);
      //     if (currentFlats.length > 0) {
      //       this.flat = currentFlats[0];
      //       this.items = currentFlats;
      //       this.items[0].curFloorPanorama = floor.floor.panoramaView;
      //       console.log('flatT: ', this.flat);
      //     }
      //   });
      //   if (this.flat.faltPrototype !== '' || this.flat.faltPrototype !== undefined) {
      //     this.dataService
      //       .getSpecFlatPrototypeView(this.flat.faltPrototype)
      //       .subscribe(prototype => {
      //         this.flatProperties = prototype[0];
      //       });
      //   }
      // })
      this.dataService.getSpecProject(this.route.snapshot.paramMap.get('idp')).subscribe(proj => {
        this.projPassFromMenu(proj);
      })
    }
  }
  projPassFromMenu(proj) {
    this.proj = proj;
    let str = this.proj[0].spirical
    str = str.slice(str.indexOf('src') + 5);
    this.mainSpiricalSrc = str.slice(0, str.indexOf('"'));
    this.mainSpiricalSrcUpdated = true;
  }

  viewFloors(item) {
    firstStep();
    function firstStep() {
      setTimeout(function () {
        if (document.getElementsByClassName("panorama-holder")) {
          let test = document.getElementsByClassName("panorama-holder");
          if (test.length > 0) {
            if (test[0].getElementsByTagName('iframe')[0]) {
              nextStep();
            }
          }
        } else {
          firstStep();
        }
      }, 1000);
    }
    function nextStep() {
      var data = {
        scene: item.curFloorPanorama, // pano ID
        autorotate: false,
      };
      // Set url to be sure that the message will be sent to only this url
      // Full url to iframe

      postMessageToIframe(data);

      // var url = 'https://topeye.club/';


      // //  Access iframe by name
      // // var win = window.frames.tourIframe;
      // const test = document.getElementsByClassName("panorama-holder");
      // const test1 = test[0].getElementsByTagName('iframe')[0];
      // var win = test1;

      // let iframeElement = eval("(win.contentWindow || win.contentDocument)");

      // iframeElement.postMessage(JSON.stringify(data), url);
    }
  }


  toggleFullScreen(): void {
    const fsDoc = <any>document;

    if (!isFullScreen()) {
      const fsDocElem = <FsDocumentElement>document.documentElement;
      this.fullscreen = true;
      if (fsDocElem.requestFullscreen) {
        fsDocElem.requestFullscreen();
      } else if (fsDocElem.msRequestFullscreen) {
        fsDocElem.msRequestFullscreen();
      } else if (fsDocElem.mozRequestFullScreen) {
        fsDocElem.mozRequestFullScreen();
      } else if (fsDocElem.webkitRequestFullscreen) {
        fsDocElem.webkitRequestFullscreen();
      }
    } else if (fsDoc.exitFullscreen) {
      fsDoc.exitFullscreen();
      this.fullscreen = false;
    } else if (fsDoc.msExitFullscreen) {
      fsDoc.msExitFullscreen();
      this.fullscreen = false;
    } else if (fsDoc.mozCancelFullScreen) {
      fsDoc.mozCancelFullScreen();
      this.fullscreen = false;
    } else if (fsDoc.webkitExitFullscreen) {
      fsDoc.webkitExitFullscreen();
      this.fullscreen = false;
    }
  }
  bigDrawing() {
    this.fullScreenDrawing = !this.fullScreenDrawing
  }
  bigSpirical() {
    this.fullScreenSpirical = !this.fullScreenSpirical
  }
  bigInterior() {
    this.fullScreenInterior = !this.fullScreenInterior
  }
  bigGallery() {
    this.fullScreenGallery = !this.fullScreenGallery
  }

}
